import * as React from 'react';

import {
  type SxProps,
  type Theme,
  ToggleButton,
  ToggleButtonGroup,
  type ToggleButtonGroupProps,
} from '@mui/material';

import styles from './StlToggle.module.css';

export type ToggleOption = {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
};

interface StlToggleProps extends ToggleButtonGroupProps {
  options: ToggleOption[];
  ariaLabel?: string;
  groupSx?: SxProps<Theme>;
  buttonSx?: SxProps<Theme>;
  onChange?: (_e: React.MouseEvent<HTMLElement>, newValue: any) => void;
}

export function StlToggle(props: StlToggleProps) {
  const { options, value, onChange, ariaLabel, groupSx, buttonSx } = props;

  return (
    <ToggleButtonGroup
      exclusive
      value={value as any}
      onChange={onChange}
      aria-label={ariaLabel}
      sx={groupSx}
      className={styles.toggle_group}
    >
      {options.map((opt) => (
        <ToggleButton
          key={String(opt.value)}
          className={styles.toggle_button}
          value={opt.value}
          disabled={opt.disabled}
          disableRipple
          sx={buttonSx}
        >
          {opt.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
